import { useState } from 'react'
import { useLocation } from "react-router-dom";

export const useSignup = () => {
  const [error, setError] = useState(null)
  const [isLoading, setIsLoading] = useState(false)
  const location = useLocation();

  const checkEmail = async (email) => {
    setIsLoading(true)
    setError(null)

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/check-email`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email })
      })
      const json = await response.json()

      if (!response.ok) {
        setIsLoading(false)
        setError(json.error)
        return false
      }

      setIsLoading(false)
      return true
    } catch (err) {
      setIsLoading(false)
      setError('Er is iets misgegaan. Probeer het opnieuw.')
      return false
    }
  }

  const signup = async (email, password) => {
    setIsLoading(true);
    setError(null);
  
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/user/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password }),
      });
      const json = await response.json();
  
      if (!response.ok) {
        setIsLoading(false);
        setError(json.error);
        return;
      }

      const searchParams = new URLSearchParams(location.search);
      const refParam = searchParams.get("ref");

      // Toon een succesbericht (bijv. via alert of een UI-indicator)
      alert('Wachtwoord succesvol ingesteld! Je wordt doorgestuurd naar de login-pagina.');
  
      // Wacht 1 seconden en stuur gebruiker door
      setTimeout(() => {
        window.location.href = `/login?ref=${refParam || "pvangeest"}`;
      }, 1000);
  
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      setError('Er is iets misgegaan bij het registreren.');
    }
  };
  
  return { signup, checkEmail, isLoading, error };
}
